import React, { createContext, useState, useCallback, useMemo } from 'react';

export const ResponseTemplateStateContext = createContext();
export const ResponseTemplateSetStateContext = createContext();

export const ResponseTemplateModalProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const [init, setInit] = useState(null);

  const open = useCallback((data) => {
    setVisible(true);

    if (data) {
      setInit(data);
    }
  }, []);

  const close = useCallback(() => {
    setVisible(false);
    setInit(null);
  }, []);

  const state = useMemo(() => ({ visible, init }), [visible, init]);
  const actions = useMemo(() => ({ open, close }), [open, close]);

  return (
    <ResponseTemplateStateContext.Provider value={state}>
      <ResponseTemplateSetStateContext.Provider value={actions}>
        {children}
      </ResponseTemplateSetStateContext.Provider>
    </ResponseTemplateStateContext.Provider>
  );
};
